import { render, staticRenderFns } from "./QuestionDragAndDrop.vue?vue&type=template&id=2dec967c&"
import script from "./QuestionDragAndDrop.vue?vue&type=script&lang=js&"
export * from "./QuestionDragAndDrop.vue?vue&type=script&lang=js&"
import style0 from "./QuestionDragAndDrop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports